import { Header } from "../component/home/Header";
import { HeroHeadline } from "../component/home/HeroHeadline";
import { HeroLoanCalculator } from "../component/home/HeroLoanCalculator";
import { HeroBannerVisual } from "../component/home/HeroBannerVisual";
import { LoanOptions } from "../component/home/LoanOptions";
import { LoanApplicationForm } from "../component/home/LoanApplicationForm";
import { HowItWorks } from "../component/home/HowItWorks";
import { WhyGenzPaisa } from "../component/home/WhyGenzPaisa";
import { Testimonials } from "../component/home/Testimonials";
import { FaqSecurity } from "../component/home/FaqSecurity";
import { Footer } from "../component/home/Footer";
// import { ChatbotWidget } from "../component/home/ChatbotWidget";

export function HomePage() {
  return (
    <div className="min-h-screen w-full bg-white">
      <Header />

      <main>
        <div className="mx-auto w-full max-w-[1280px] px-4">
          <HeroHeadline />
        </div>

        <div className="mx-auto w-full max-w-[1280px] px-4">
          <HeroLoanCalculator />
        </div>

        <HeroBannerVisual />

        <LoanOptions />
        <LoanApplicationForm />
        <HowItWorks />
        <WhyGenzPaisa />
        <Testimonials />
        <FaqSecurity />
      </main>

      <Footer />
      {/* <ChatbotWidget /> */}
    </div>
  );
}
